import { setNotification } from "features/Notification/notificationSlice";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function SearchComp({ setLoading, apiPath, clearFunc }) {
  /*   All States
   ********************************************* */
  const [searchText, setSearchText] = useState("");
  const [showClearButton, setShowClearButton] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  /*   All Functions
   ********************************************* */
  /**
   * Drop `page` from the caller's apiPath.
   *
   * Callers strip `query` but keep the rest of the URL, so a search fired while
   * sitting on page 4 asked the API for page 4 OF THE SEARCH RESULTS. A search
   * matching a single page then returns nothing and the list reads "no results
   * found" for a query that does match. Clear had the same problem.
   *
   * Every list treats a missing `page` as page 1, so removing it is all that is
   * needed. The trailing separator is normalised here too, because callers
   * append "query=..." straight onto this string.
   */
  const resetToFirstPage = (path) => {
    if (!path) return path;
    const cut = path.indexOf("?");
    if (cut === -1) return `${path}?`;

    const base = path.slice(0, cut);
    const params = new URLSearchParams(path.slice(cut + 1));
    params.delete("page");
    const rest = params.toString();
    return rest ? `${base}?${rest}&` : `${base}?`;
  };

  const updateSearchText = (text) => {
    setSearchText(text);
  };

  const searchData = async (e) => {
    e.preventDefault();
    if (searchText === "") {
      dispatch(
        setNotification({
          message: "Please enter a valid query",
          type: "error",
        }),
      );
      return;
    }
    setLoading(true);

    try {
      navigate(`${resetToFirstPage(apiPath)}query=` + searchText);

      setLoading(false);
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        }),
      );
      setLoading(false);
    }
  };

  const handleClearButton = () => {
    setShowClearButton(false);
    setSearchText("");
    navigate(resetToFirstPage(apiPath));
    clearFunc && clearFunc();
  };

  /*   All UseEffects
   ********************************************* */
  useEffect(() => {
    let query = searchParams.get("query");
    if (query) {
      setShowClearButton(true);
    } else {
      setShowClearButton(false);
    }
  }, [searchParams]);

  useEffect(() => {
    setSearchText(searchParams.get("query"));
  }, [searchParams]);
  return (
    <div className="d-flex">
      <form onSubmit={searchData} className="me-1 d-flex gap-1">
        <input
          onChange={(e) => {
            updateSearchText(e.target.value.toLocaleLowerCase());
          }}
          className="form-control"
          placeholder="Search here..."
          value={searchText || ""}
          type="text"
        />

        <button
          type="submit"
          disabled={!searchText || searchText === ""}
          className="btn btn- btn-info"
        >
          Search
        </button>
      </form>
      {showClearButton && (
        <button onClick={handleClearButton} className="btn btn- btn-danger">
          Clear
        </button>
      )}
    </div>
  );
}
